<template>
  <div>
    <section class="hero is-primary">
      <div class="hero-body">
        <div class="container">
          <FeedRelations/>
        </div>
      </div>
    </section>
    <div class="container">
      <FeedList/>
      <LoggedInDisplayer/>
    </div>
  </div>
</template>

<script>
import LoggedInDisplayer from '@/components/LoggedInDisplayer'
import FeedList from '@/components/FeedList'
import FeedRelations from '@/components/FeedRelations'
export default {
  components: {
    LoggedInDisplayer,
    FeedList,
    FeedRelations
  }
}
</script>

<style scoped>
  .hero {
    margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PageFeed.vue